<div>
  <div class="pure-menu pure-menu-horizontal">
    <span class="pure-menu-heading">Manage Permissions</span>
  </div>
  <div class="pure-menu pure-menu-horizontal">
    <ul class="pure-menu-list">
      <li
        class="pure-menu-item"
        [ngClass]="{ 'pure-menu-selected': selected == 1 }"
      >
        <a
          class="pure-menu-link"
          (click)="assignComponent('manageUserPermissionsComponent')"
          >Manage permissions
        </a>
      </li>
      <li
        class="pure-menu-item"
        [ngClass]="{ 'pure-menu-selected': selected == 2 }"
      >
        <a
          class="pure-menu-link"
          (click)="assignComponent('viewUpdatedUserPermissionsComponent')"
          >View permissions
        </a>
      </li>
      <li
        class="pure-menu-item"
        [ngClass]="{ 'pure-menu-selected': selected == 3 }"
      >
        <a
          class="pure-menu-link"
          (click)="assignComponent('addNewPermissionsComponent')"
          >Add new permissions
        </a>
      </li>
    </ul>
  </div>

  <div>
    <ng-container *ngComponentOutlet="desiredComponent"></ng-container>
  </div>
</div>
